module.exports = __webpack_public_path__ + "img/odontogram_legend.f34f2dde.png";